import React, { useState } from 'react';
import api from '../../services/api';
import { Button } from '../UI/Button.js';
import CustomDatePicker from '../Common/DatePicker';
import { FormContainer, FullWidth } from '../../styles/sharedStyles';
import Select from 'react-select';

const AdminAddHoliday = () => {
  const [holidayDate, setHolidayDate] = useState('');
  const [holidayName, setHolidayName] = useState('');
  const [holidayType, setHolidayType] = useState('');

  const holidayTypeOptions = [
    { value: 'Annual', label: 'Festivo por año' },
    { value: 'Common', label: 'Festivo común' }
  ];

  const handleAdminAddHoliday = async () => {
    if (!holidayDate || !holidayName || !holidayType) {
      alert('Por favor completa todos los campos');
      return;
    }

    const params = new URLSearchParams();
    params.append('holiday_date', holidayDate.toLocaleDateString('en-CA')); // YYYY-MM-DD
    params.append('holiday_name', holidayName);
    params.append('holiday_type', holidayType);

    try {
      const response = await api.post(`/addholiday?${params.toString()}`);
      alert(response.data.message);
      setHolidayDate(null);
      setHolidayName('');
      setHolidayType('');
    } catch (error) {
      console.error('Adding holiday failed', error);
      alert('Error al añadir el festivo');
    }
  };

  return (
    <div>
      <h2>Añadir festivos</h2>
      <FormContainer>
        <FullWidth>
          <Select
            value={holidayTypeOptions.find(opt => opt.value === holidayType)}
            onChange={(selected) => setHolidayType(selected ? selected.value : '')}
            options={holidayTypeOptions}
            placeholder="Selecciona tipo de festivo"
            isClearable
          />
        </FullWidth>

        <FullWidth>
          <CustomDatePicker
            selected={holidayDate}
            onChange={(date) => setHolidayDate(date)}
            placeholder="Selecciona la fecha"
            isRequired={true}
          />
        </FullWidth>

        <FullWidth>
          <input
            type="text"
            value={holidayName}
            onChange={(e) => setHolidayName(e.target.value)}
            placeholder="Nombre del festivo"
            required
            style={{ width: '100%', padding: '8px' }}
          />
        </FullWidth>

        <FullWidth>
          <Button onClick={handleAdminAddHoliday}>Añadir</Button>
        </FullWidth>
      </FormContainer>
    </div>
  );
};

export default AdminAddHoliday;
